import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

export default class Common {
  // 获取项目列表
  static async getSiteList() {
    const [err, res] = await To(wizStandardInstance.get('/api/Sites/GetSitesAsync'))
    return Callback(err, res)
  }
  // 获取用户权限
  static async getUserAuth() {
    const [err, res] = await To(wizStandardInstance.get('/api/qs/api/authorize/get_user_authorize'))
    return Callback(err, res)
  }
  // 获取员工信息
  static async getEmpInfo(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/qs/api/common/employee_list/${payload.id}`)
    )
    return Callback(err, res)
  }
  // 部门id获取部门下所有人员
  static async getDepartEmp(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/qs/api/common/get_department_employee/${payload.id}`)
    )
    return Callback(err, res)
  }
  // 审批，不走工作流
  static async submitFlow(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/qs/api/common/submit_flow', payload))
    return Callback(err, res)
  }
  // 验证签章密码
  static async validateSignPwd(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/qs/api/hr_emp_employee/validate_signature_pwd/${payload.password}`
      )
    )
    return Callback(err, res)
  }
  // 获取用户树，带部门
  static async apiUserTree() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/qs/api/hr_emp_department/rf_department_employeetree')
    )
    return Callback(err, res)
  }
  // 获取部门树
  static async getTreeList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/qs/api/hr_emp_department/department_tree/${payload.time}`)
    )
    return Callback(err, res)
  }
  // 部门列表
  static async getDepartList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/qs/api/hr_emp_department/${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 人员列表下拉
  static async getEmpList() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/qs/api/hr_emp_employee/get_select_data')
    )
    return Callback(err, res)
  }
  // 获取签名
  static async apiSignName(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/qs/api/hr_emp_employee?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 上传附件
  static async upload(
    arg = {
      payload: {},
      formData: {},
    }
  ) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/qs/api/common/upload_attachment', arg.formData, {
        'Content-Type': 'multipart/form-data',
      })
    )
    return Callback(err, res)
  }
  // 获取附件
  static async getAttach(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/qs/api/common/get_attachment_list/${payload.id}/${payload.typeId}`
      )
    )
    return Callback(err, res)
  }
  // 删除附件
  static async removeAttch(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/qs/api/common/delete_attachment_by_id', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 通过表单ID获取流程信息（非工作流）
  static async apiFlowInfo(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/qs/api/common/get_workflow_by_formid/${payload.id}`)
    )
    return Callback(err, res)
  }
  // 下载模板
  static async downloadTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/qs/api/std/Common/download', payload)
    )
    return Callback(err, res)
  }
  // 获取下拉框数据
  static async findSourceData(url) {
    const [err, res] = await To(wizStandardInstance.get(`/api/${url}`))
    return Callback(err, res)
  }
  // 获取模板
  static async findCodeTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/CodeTemplate?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取主表
  static async findMatinTable(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/${payload.reqUrl}?${qs.stringify(payload.reqData)}`)
    )
    return Callback(err, res)
  }
  static async detail(payload) {
    const [err, res] = await To(wizStandardInstance.get(`​/api/qs/DicCate/${payload.id}`))
    return Callback(err, res)
  }
  static async list(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/${payload.reqUrl}?${qs.stringify(payload.reqData)}`)
    )
    return Callback(err, res)
  }
  static async create(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post(`/api/${payload.reqUrl}`, payload.reqData))
    return Callback(err, res)
  }
  static async updateDIY(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.put(`/api/${payload.reqUrl}`, payload.reqData))
    return Callback(err, res)
  }
  static async updateSaas(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(
      wizStandardInstance.patch(`/api/${payload.reqUrl}`, payload.reqData)
    )
    return Callback(err, res)
  }
  static async remove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(
      wizStandardInstance.delete(`/api/${payload.reqUrl}`, payload.reqData)
    )
    return Callback(err, res)
  }
  static async exportFile(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(wizStandardInstance.post(`/api/${payload.reqUrl}`, payload.reqData))
    return Callback(err, res)
  }
  static async uploadFile(payload) {
    RecordOperation({ type: 'import' })
    const [err, res] = await To(
      wizStandardInstance.post(`/api/${payload.reqUrl}`, payload.reqData, {
        'Content-Type': 'multipart/form-data',
      })
    )
    return Callback(err, res)
  }
  static async downloadTemplateCommon(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/${payload.reqUrl}`))
    return Callback(err, res)
  }
  // 导入owl文件
  static async importOwl(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `/api/std/StdStandard/import_owl?standardid=${payload.standardid}`,
        payload.reqData,
        {
          'Content-Type': 'multipart/form-data',
        }
      )
    )
    return Callback(err, res)
  }
  // 导出owl文件
  static async exportOwl(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdStandard/download_owl?standardid=${payload.standardid}`)
    )
    return Callback(err, res)
  }
  // 导出数据字典
  static async exportDataDictionary(type, payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.post(`/api/${type}/excel-export`, payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 数据字典模板
  static async exportDataDictionaryTemplate(type) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/${type}/excel-impport-template`, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 导入数据字典
  static async importDataDictionary(type, payload) {
    RecordOperation({ type: 'import' })
    const [err, res] = await To(
      wizStandardInstance.post(`/api/${type}/excel-impport`, payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
}
